import { ValidatorFn } from '@angular/forms';
import { NumberMaxValueValidator, NumberMinValueValidator } from '../validations';
import { BaseInput, BaseInputConstructor } from './base-input';

/**
 * Represents the constructor options for SliderWithTextInput.
 *
 * @extends BaseInputConstructor
 */
export interface SliderWithTextInputConstructor extends BaseInputConstructor {
    defaultValue: number;
    defaultValueLabel: string;
    min?: number;
    max?: number;
    step?: number; // Aggiungiamo lo step
}

/**
 * Represents a slider with a text input field.
 *
 * @extends BaseInput
 */
export class SliderWithTextInput extends BaseInput {
    /**
     * Specifies the type of input as 'textbox'.
     */
    override inputType = 'sliderWithTextbox';
    override readonly __internalConstructor__: SliderWithTextInputConstructor;
    default: number;
    defaultValueLabel: string;
    min?: number;
    max?: number;
    step?: number; // Aggiungiamo lo step

    /**
     * Creates a new instance of TextInput.
     *
     * @param options - The options for configuring the text input.
     *
     * @property {InputControlType} options.type - The type of the input control.
     */
    constructor(options: SliderWithTextInputConstructor) {
        super(options);
        this.__internalConstructor__ = options;
        this.default = options.defaultValue;
        this.defaultValueLabel = options.defaultValueLabel;
        this.min = options.min;
        this.max = options.max;
        this.step = options.step; // Inizializziamo lo step

        const validators: ValidatorFn[] = [];
        if (this.validator) {
            validators.push(this.validator);
        }

        // se min è uguale a zero lo prende come false
        if (options?.min !== undefined) {
            validators.push(NumberMinValueValidator());
        }

        // se max è uguale a zero lo prende come false
        if (options?.max !== undefined) {
            validators.push(NumberMaxValueValidator());
        }

        this.setValidators(validators);
    }

    clone(): SliderWithTextInput {
        return new SliderWithTextInput(this.__internalConstructor__);
    }
}
